module.exports = __webpack_public_path__ + "static/media/iconMetricPM2_5.7c47a6fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMetricPM2_5.svg
// module id = 1132
// module chunks = 0